"use strict";
var __awaiter = this && this.__awaiter || function(t, n, a, c) {
    return new (a = a || Promise)(function(i, e) {
        function r(t) {
            try {
                o(c.next(t))
            } catch (t) {
                e(t)
            }
        }
        function s(t) {
            try {
                o(c.throw(t))
            } catch (t) {
                e(t)
            }
        }
        function o(t) {
            var e;
            t.done ? i(t.value) : ((e = t.value)instanceof a ? e : new a(function(t) {
                t(e)
            }
            )).then(r, s)
        }
        o((c = c.apply(t, n || [])).next())
    }
    )
}
;
class RobustCart {
    constructor(t, e, i, r, s, o, rl, rp) {
        this.log = t=>{
            window.ROBUST_CART_DEV && console.log("%cRobust Cart: " + t, "background: #cd302b; color: #fff", this)
        }
        ,
        this.createAddToCartPromise = t=>{
            t = new FormData(t),
            t = Object.fromEntries(t.entries()),
            t = JSON.stringify(t);
            return fetch(this.cartAddUrl, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: t
            })
        }
        ,
        this.createFetchCartPromise = ()=>fetch("/?section_id=robust-cart"),
        this.createUpdateCartItemPromise = (t,e,i)=>{
            var r = this.cartChangeUrl.endsWith(".js") ? this.cartChangeUrl : this.cartChangeUrl + ".js";
            var s = i ? {
                line: Number(i),
                quantity: e
            } : {
                id: t,
                quantity: e
            };
            return fetch(r, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(s)
            })
        }
        ,
        this.openCart = ()=>{
            this.rootEl.classList.add("rc90--open"),
            this.scrollPosition = window.scrollY,
            this.lockScroll()
        }
        ,
        this.closeCart = ()=>{
            this.rootEl.classList.remove("rc90--open"),
            this.unlockScroll()
        }
        ,
        this.refreshCart = ()=>__awaiter(this, void 0, void 0, function*() {
            var t = yield(yield this.createFetchCartPromise()).text()
              , e = document.createElement("div")
              , t = (e.innerHTML = t,
            e.querySelector(".rc90-box"));
            this.rootEl.querySelector(".rc90-box").innerHTML = t.innerHTML,
            this.addInnerListeners(),
            this.updateCartCount()
        }),
        this.removeCartItem = (t,e)=>__awaiter(this, void 0, void 0, function*() {
            yield this.createUpdateCartItemPromise(t, 0, e),
            yield this.refreshCart()
        }),
        this.changeCartItemQuantity = (t,e,i)=>__awaiter(this, void 0, void 0, function*() {
            yield this.createUpdateCartItemPromise(t, e, i),
            yield this.refreshCart()
        }),
        this.getCartJson = ()=>{
            var t = this.rootEl.querySelector(".robust-cart-json");
            if (t) {
                t = t.getAttribute("data-cart-json");
                if (t)
                    return JSON.parse(t)
            }
        }
        ,
        this.updateCartCount = ()=>{
            var t = this.getCartJson();
            t && document.querySelectorAll(".header-icons-anchor-cart-count").forEach(e=>{
                e.textContent = t.item_count,
                e.classList.toggle("header-icons-anchor-cart-count--hide", 0 === t.item_count)
            }
            )
        }
        ,
        this.addAllListeners = ()=>{
            this.addOpenCartListeners(),
            this.addCartBoxListener(),
            this.addInnerListeners()
        }
        ,
        this.addInnerListeners = ()=>{
            this.addCloseCartListeners(),
            this.addFormSubmissionListeners(),
            this.addItemRemoveListeners(),
            this.addItemQuantityListeners(),
            this.recommendedItemAddListener()
        }
        ,
        this.addCartBoxListener = ()=>{
            this.log("Adding cart box click listener");
            var t = this.rootEl.querySelector(".rc90-box");
            t && t.addEventListener("click", t=>{
                t.stopPropagation()
            }
            )
        }
        ,
        this.addOpenCartListeners = ()=>{
            this.log("Adding open click listeners");
            if (this.cartOpenListenersBound)
                return;
            this.cartOpenListenersBound = !0,
            document.addEventListener("click", t=>{
                var e = t.target.closest && t.target.closest('a[href]');
                if (!e)
                    return;
                try {
                    var i = new URL(e.getAttribute("href"), window.location.origin)
                      , r = (this.cartUrl || "/cart").replace(/\/$/, "");
                    if (i.pathname.replace(/\/$/, "") !== r)
                        return;
                    t.preventDefault(),
                    t.stopPropagation(),
                    this.refreshCart().finally(()=>this.openCart())
                } catch (t) {}
            }
            , !0)
        }
        ,
        this.addCloseCartListeners = ()=>{
            this.log("Adding close click listeners"),
            this.rootEl.addEventListener("click", this.closeCart),
            this.rootEl.querySelectorAll(".rc90-header-close, .rc90-buttons-continue-shopping, .rc90-empty-inner-continue").forEach(t=>{
                t.addEventListener("click", this.closeCart)
            }
            )
        }
        ,
        this.addFormSubmissionListeners = ()=>{
            this.log("Adding add form submission listeners");
            if (this.cartFormListenersBound)
                return;
            this.cartFormListenersBound = !0;
            const t = t=>{
                if (!t)
                    return !1;
                try {
                    var e = new URL(t.getAttribute("action") || t.action || "", window.location.origin);
                    return e.pathname.replace(/\/$/, "") === "/cart/add"
                } catch (t) {
                    return !1
                }
            }
            ;
            document.addEventListener("submit", e=>__awaiter(this, void 0, void 0, function*() {
                var i = e.target.closest && e.target.closest("form");
                if (!t(i) || this.isAddingToCart)
                    return;
                e.preventDefault(),
                e.stopPropagation(),
                this.isAddingToCart = !0;
                try {
                    var r = yield this.createAddToCartPromise(i);
                    r.ok && (yield this.refreshCart(),
                    this.openCart())
                } finally {
                    this.isAddingToCart = !1
                }
            }), !0),
            document.addEventListener("click", e=>__awaiter(this, void 0, void 0, function*() {
                var i = e.target.closest && e.target.closest('form button[name="add"], form [type="submit"], form [data-add-to-cart]');
                if (!i)
                    return;
                var r = i.closest("form");
                if (!t(r) || this.isAddingToCart)
                    return;
                e.preventDefault(),
                e.stopPropagation(),
                this.isAddingToCart = !0;
                try {
                    var s = yield this.createAddToCartPromise(r);
                    s.ok && (yield this.refreshCart(),
                    this.openCart())
                } finally {
                    this.isAddingToCart = !1
                }
            }), !0)
        }
        ,
        this.addItemRemoveListeners = ()=>{
            this.log(this.rootEl),
            this.log("Adding remove item click listeners"),
            this.rootEl.querySelectorAll(".rc90-item-main-header-remove").forEach(e=>{
                e.addEventListener("click", ()=>{
                    var t = e.getAttribute("data-line-item-key")
                      , i = e.getAttribute("data-line-item-line");
                    (t || i) && this.removeCartItem(t, i)
                }
                )
            }
            )
        }
        ,
        this.addItemQuantityListeners = ()=>{
            this.rootEl.querySelectorAll(".rc90-item-main-footer-quantity-plus, .rc90-item-main-footer-quantity-minus").forEach(t=>{
                var e = t.classList.contains("rc90-item-main-footer-quantity-plus");
                const i = t.getAttribute("data-line-item-key")
                  , o = t.getAttribute("data-line-item-line");
                var r = Number(t.getAttribute("data-quantity"));
                if (i && r) {
                    const s = e ? r + 1 : r - 1;
                    t.addEventListener("click", ()=>__awaiter(this, void 0, void 0, function*() {
                        yield this.changeCartItemQuantity(i, s, o)
                    }))
                }
            }
            )
        },
        this.lockScroll = ()=>{
            var t = this.scrollPosition
              , e = document.body;
            e.style.position = "fixed",
            e.style.top = `-${t}px`
        }
        ,
        this.unlockScroll = ()=>{
            var t = document.body
              , e = t.style.top;
            t.style.position = "",
            t.style.top = "",
            window.scrollTo(0, -1 * parseInt(e || "0"))
        }
        ,
        this.log("Initializing"),
        this.cartUrl = r,
        this.cartAddUrl = s,
        this.cartChangeUrl = o,
        this.rootEl = t,
        this.country = e,
        this.currency = i,
        this.recommendedItemAddListener = rl,
        this.recommendedProducts = rp,
        this.scrollPosition = window.scrollY,
        this.addAllListeners(),
        this.log("Initialized")
    }
}
